export default {
  TITLE: 'Hero Hive',
}
